import { getSessionToken } from "@shopify/app-bridge-utils"
import Turbolinks from "turbolinks" // Declare Turbolinks variable

const SESSION_TOKEN_REFRESH_INTERVAL = 2000 // Request a new token every 2s

// Intercept all Turbolinks requests and add session token
document.addEventListener("turbolinks:request-start", (event) => {
  var xhr = event.data.xhr
  if (window.sessionToken) {
    xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken)
  }
})

// Handle XHR responses that indicate token expiry
document.addEventListener("turbolinks:request-end", async (event) => {
  const xhr = event.data.xhr
  
  // Check if server returned retry header (token expired)
  if (xhr.getResponseHeader("X-Shopify-Retry-Invalid-Session-Request")) {
    console.log("Session token expired, refreshing and retrying...")
    
    // Refresh the token
    if (window.app) {
      await retrieveToken(window.app)
      
      // Retry the request with new token
      Turbolinks.visit(event.data.url)
    }
  }
})

document.addEventListener("turbolinks:render", () => {
  const forms = document.querySelectorAll("form, a[data-method=delete]")
  forms.forEach((element) => {
    element.addEventListener("ajax:beforeSend", (event) => {
      const xhr = event.detail[0]
      if (window.sessionToken) {
        xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken)
      }
    })
  })
})

document.addEventListener("DOMContentLoaded", async () => {
  const initElement = document.getElementById("shopify-app-init")

  if (initElement == null) {
    return null
  }

  const data = initElement.dataset
  const AppBridge = window["app-bridge"]

  if (!AppBridge) {
    console.error("Shopify App Bridge not loaded")
    return
  }

  const createApp = AppBridge.default

  try {
    // Create app instance in window
    window.app = createApp({
      apiKey: data.apiKey,
      host: data.host,
      forceRedirect: true,
    })

    console.log("Shopify App Bridge initialized")

    const Navigation = AppBridge.actions.Navigation
    if (Navigation) {
      window.appNavigation = Navigation.create(window.app)
      console.log("App Bridge Navigation initialized")
    }

    // Wait for a session token before trying to load an authenticated page
    await retrieveToken(window.app)

    // Keep retrieving a session token periodically
    keepRetrievingToken(window.app)

    document.addEventListener("turbolinks:load", (event) => {
      if (event.data && event.data.url) {
        console.log("TURBO:", event.data.url, location.origin)
      }

      // Update Shopify admin URL bar with current path
      if (window.appNavigation) {
        const currentPath = window.location.pathname + window.location.search
        console.log("Updating Shopify admin URL to:", currentPath)
        window.appNavigation.dispatch(Navigation.Action.PUSH, currentPath)
      }

      redirectThroughTurbolinks()
    })

    // Redirect to the requested page when DOM loads
    var isInitialRedirect = true
    redirectThroughTurbolinks(isInitialRedirect)
  } catch (error) {
    console.error("Error initializing Shopify App Bridge:", error)
  }
})

// Helper functions
function redirectThroughTurbolinks(isInitialRedirect = false) {
  var data = document.getElementById("shopify-app-init")?.dataset
  var validLoadPath = data && data.loadPath
  var shouldRedirect = false

  switch (isInitialRedirect) {
    case true:
      shouldRedirect = validLoadPath
      break
    case false:
      shouldRedirect = validLoadPath && data.loadPath !== "/home"
      break
  }

  if (shouldRedirect && typeof Turbolinks !== "undefined") {
    Turbolinks.visit(data.loadPath)
  }
}

async function retrieveToken(app) {
  try {
    window.sessionToken = await getSessionToken(app)
    console.log("Session token retrieved successfully")
  } catch (error) {
    console.error("Error retrieving session token:", error)
    
    // If we can't get a session token, the user may need to reauthorize
    if (error.message && error.message.includes("authentication")) {
      console.error("Authentication failed. User may need to reinstall app.")
    }
  }
}

function keepRetrievingToken(app) {
  setInterval(() => {
    retrieveToken(app)
  }, SESSION_TOKEN_REFRESH_INTERVAL)
}
